import { render, staticRenderFns } from "./SongWave.vue?vue&type=template&id=0bf6011a&"
import script from "./SongWave.vue?vue&type=script&lang=js&"
export * from "./SongWave.vue?vue&type=script&lang=js&"
import style0 from "./SongWave.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports